import { afterNextRender, Component, Input, input } from '@angular/core';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

export class GalleryImage {
  href: string;
  width: number;
  height: number;
  alt: string;
  thumbnailUrl: string;
  thumbnailWidth: number;
  thumbnailHeight: number;

  constructor(href: string, width: number, height: number, alt: string) {
    this.href = href;
    this.width = width;
    this.height = height;
    this.alt = alt;
    const lastSlashIndex = this.href.lastIndexOf('/');
    this.thumbnailUrl = `${this.href.substring(0, lastSlashIndex)}/thumbs/${this.href.substring(lastSlashIndex + 1)}`;

    // Set the fixed height as defined in the CSS.
    this.thumbnailWidth = 300;
    // Calculate the width that preserves the original aspect ratio.
    this.thumbnailHeight = Math.min(Math.round((this.height / this.width) * this.thumbnailWidth), 150);

    // The final width is the lesser of the calculated width and the CSS max-width.
    // this.thumbnailWidth = Math.min(preservedWidth, 300);
  }
}

@Component({
  selector: 'app-gallery',
  imports: [],
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss',
})
export class GalleryComponent {
  @Input() images!: GalleryImage[];
  @Input() maxWidth: string = '700px';
  @Input() maxThumbs?: number = undefined;
  get imageCount(): number {
    return this.images ? this.images.length : 0;
  }
  get hiddenImageCount(): number {
    if (!this.maxThumbs || this.imageCount <= this.maxThumbs) {
      return 0;
    }
    return this.imageCount - this.maxThumbs;
  }
  Infinity = Infinity;
  constructor() {
    afterNextRender(() => {
      const lightbox = new PhotoSwipeLightbox({
        // may select multiple "galleries"
        gallery: '#gallery',

        // Elements within gallery (slides)
        children: 'a',
        bgOpacity: 0.85,
        wheelToZoom: true,
        closeOnVerticalDrag: true,
        clickToCloseNonZoomable: false,
        indexIndicatorSep: ' of ',
        pswpModule: PhotoSwipe,
      });
      lightbox.init();
    });
  }
}
